/*
 * @Author: Hong.Zhang
 * @Date: 2024-12-02 18:19:16
 * @Description:
 */
let platform = {};
try {
  platform = require(`./id-ID/index.json`);
} catch (e) {}
export default {
  ...platform,
};
